import { cn } from "@/lib/utils";

interface SkipToContentProps {
  mainId?: string;
  className?: string;
}

/**
 * Skip to content link for keyboard navigation and screen readers
 * Allows users to bypass repetitive navigation and jump directly to main content
 */
export function SkipToContent({ mainId = "main-content", className }: SkipToContentProps) {
  return (
    <a
      href={`#${mainId}`}
      className={cn(
        "sr-only focus:not-sr-only",
        "fixed top-4 left-4 z-[9999]",
        "border border-gold/25 bg-gold/10 text-gold font-semibold",
        "px-4 py-2 rounded-md",
        "focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-charcoal",
        "transition-all duration-200",
        className
      )}
    >
      Skip to main content
    </a>
  );
}
